import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Search from '../views/Search.vue';
import Stepper from '../views/Stepper.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/c/userdata",
    name: "Home",
    component: Stepper,
  },
  {
    path: "/c/affordable-housing-locator",
    name: "Search",
    component: Search,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
